import { render, staticRenderFns } from "./JciEventTypeEdit.vue?vue&type=template&id=081bcd08"
import script from "./JciEventTypeEdit.vue?vue&type=script&lang=js"
export * from "./JciEventTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./JciEventTypeEdit.vue?vue&type=style&index=0&id=081bcd08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports